import * as React from "react";
import { IconProps } from "./IconProps";

export const IconServer = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.66699 4.39144C1.66699 3.9312 2.04009 3.55811 2.50033 3.55811H17.5003C17.9606 3.55811 18.3337 3.9312 18.3337 4.39144V16.0581C18.3337 16.5183 17.9606 16.8914 17.5003 16.8914H2.50033C2.04009 16.8914 1.66699 16.5183 1.66699 16.0581V4.39144ZM3.33366 5.22477V9.39144H16.667V5.22477H3.33366ZM16.667 11.0581H3.33366V15.2248H16.667V11.0581Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.45866 7.30811C6.45866 7.8834 5.99229 8.34977 5.41699 8.34977C4.8417 8.34977 4.37533 7.8834 4.37533 7.30811C4.37533 6.73281 4.8417 6.26644 5.41699 6.26644C5.99229 6.26644 6.45866 6.73281 6.45866 7.30811ZM6.45866 13.1414C6.45866 13.7167 5.99229 14.1831 5.41699 14.1831C4.8417 14.1831 4.37533 13.7167 4.37533 13.1414C4.37533 12.5661 4.8417 12.0998 5.41699 12.0998C5.99229 12.0998 6.45866 12.5661 6.45866 13.1414Z"
          fill={color}
        />
      </svg>
    );
  },
);
